module.exports = __webpack_public_path__ + "img/unit-bulding.ae0104a0.svg";